import { graphql, useFragment } from "react-relay";
import type { postAttachmentsPreview_post$key } from "./__generated__/postAttachmentsPreview_post.graphql";
import { Attachment } from "./attachment";

export function PostAttachmentsPreview({
	post,
}: {
	post: postAttachmentsPreview_post$key;
}) {
	const data = useFragment<postAttachmentsPreview_post$key>(
		graphql`
    fragment postAttachmentsPreview_post on Post {
      id

      attachments {
        id
        originalName
        size
        signedUrl
      }
    }
  `,
		post,
	);

	if (!data.attachments?.length) {
		return null;
	}

	return (
		<div className="flex flex-row gap-3 flex-wrap">
			{data.attachments.map((att) => (
				<Attachment
					id={att.id}
					key={att.id}
					name={att.originalName}
					size={att.size || undefined}
					url={att.signedUrl}
				/>
			))}
		</div>
	);
}
